// extracted by mini-css-extract-plugin
module.exports = {"swipeContainer":"ExtendedPinchPanContainer_swipeContainer__36zxf","extendedPinchPanContainer":"ExtendedPinchPanContainer_extendedPinchPanContainer__8r90v"};